module.exports = __webpack_public_path__ + "img/users.ef347fde.svg";